import { ACCEPT_BUY_NOW, CLOSE_BUY_NOW_MODAL, OPEN_DEMO_MODAL } from 'dealer-reducers'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import Button from 'src/components/atoms/Button'
import Space from 'src/components/atoms/Space'
import Text from 'src/components/atoms/TextNew'
import View from 'src/components/atoms/View'
import { formatPrice } from 'src/helpers/formatPrice'
import useDealerAllowedToPlaceOffer from 'src/hooks/useDealerAllowedToPlaceOffer'
import track from 'src/helpers/track'

interface Props {
  offerId: number
  buyNowPrice: number
}
const BuyNowModalContent = ({ offerId, buyNowPrice }: Props): JSX.Element => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const dealerAllowedToPlaceOffer = useDealerAllowedToPlaceOffer()

  return (
    <View className="flex flex-col h-full">
      <Space y={40} />
      <View>
        <Text className="text-xl text-white text-center font-SemiBold max-w-[400px] mx-auto">
          <>{t('buy_now_modal.title')}</>
        </Text>
        <View className="min-w-[200px] flex justify-center items-center text-center">
          <Text className="text-xxl  text-white font-SemiBold">€ {formatPrice(buyNowPrice)}</Text>
        </View>
      </View>
      <View className="flex-1" />
      <View>
        <View className=" text-white text-l text-center">
          {t('buy_now_modal.by_clicking')} <strong>{t('buy_now_modal.buy_now')}</strong>{' '}
          {t('buy_now_modal.you_realize_sell')} <strong> {t('buy_now_modal.terms')}</strong>
        </View>
        <Space y={4} />
        <View className="flex gap-2 justify-center">
          <Button color="transparent" variant="medium" onClick={() => dispatch(CLOSE_BUY_NOW_MODAL())}>
            <Text className="text-xl text-white font-SemiBold">
              <>{t('auction_contract_modal.resign')}</>
            </Text>
          </Button>
          <Button
            variant="medium"
            customStyles="!rounded-[10px] !w-[144px]"
            disabled={!dealerAllowedToPlaceOffer}
            onClick={() => {
              if (!dealerAllowedToPlaceOffer) {
                dispatch(OPEN_DEMO_MODAL())
                return
              }
              track('dealer_meaningful_action')
              dispatch(ACCEPT_BUY_NOW({ offerId }))
            }}>
            <Text className="text-xl  text-white font-SemiBold">
              <>{t('buy_now_modal.buy_now_button')}</>
            </Text>
          </Button>
        </View>
        <Space y={10} />
      </View>
    </View>
  )
}

export default BuyNowModalContent
